import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/user2/Desktop/MDM/UdmsClient/uss/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/user2/Desktop/MDM/UdmsClient/uss/src/app/(public)/pricing-plans/components/PricingInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/user2/Desktop/MDM/UdmsClient/uss/src/components/ui/AppIcon.tsx");
